import { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import logo2 from '../images/waves_ws.png'
import {
  useUser,
  useLang,
  useListSessionsWS,
  useSessionWS,
  useListBoards,
  useListSails,
  useTrkptsWS,
} from '../utils/hooks'

import { langHeader } from '../assets/langHeader'

import { WiDayWindy } from 'react-icons/wi'
import { FiWind } from 'react-icons/fi'
import { MdGpsNotFixed } from 'react-icons/md'
import { MdSurfing } from 'react-icons/md'
import { MdKitesurfing } from 'react-icons/md'
import { AiOutlineDotChart } from 'react-icons/ai'
import { GiChart } from 'react-icons/gi'
import { noAccount, subscribeAccount } from '../assets/accounts'

const Header = () => {
  const { user, changeUser } = useUser()
  const { lang, toggleLang } = useLang()
  const { setListSessionsWS } = useListSessionsWS()
  const { changeSessionWS } = useSessionWS()
  const { setListBoards } = useListBoards()
  const { setListSails } = useListSails()
  const { changeTrkptsWS } = useTrkptsWS()
  const [isActive, setIsActive] = useState(false)
  const demoUserName = process.env.REACT_APP_DEMO_USERNAME

  const navigateTo = useNavigate()

  const choosenLang = lang === 'eng' ? langHeader.eng : langHeader.fr

  const handleDisconnect = () => {
    changeUser({
      userName: '',
      userId: -1,
      accountType: noAccount,
      subscribeStart: null,
      subscribeEnd: null,
      subscribeLength: null,
    })

    localStorage.setItem('wsurf_userName', '')
    localStorage.setItem('wsurf_userId', '-1')
    localStorage.setItem('wsurf_subscribeAccount', noAccount)
    localStorage.setItem('wsurf_subscribeStart', '')
    localStorage.setItem('wsurf_subscribeEnd', '')
    setListSessionsWS({ type: 'RESET_SESSIONS' })
    changeSessionWS(null)
    changeTrkptsWS({
      brut: [],
      origin: '',
    })
    setListBoards({ type: 'RESET_BOARDS' })
    setListSails({ type: 'RESET_SAILS' })
    navigateTo('/')
  }

  const handleModifyProfile = () => {
    navigateTo('/modifyProfile')
  }

  return (
    <nav
      className="navbar is-fixed-top pr-6 has-background-info-95"
      role="navigation"
      aria-label="main navigation"
      style={{ zIndex: '10000' }}
    >
      <div className="navbar-brand">
        <Link
          to={user.userId === -1 ? '/' : '/sessions'}
          className="navbar-item"
        >
          <>
            <img src={logo2} alt="logo2"></img>
          </>
        </Link>
        <a
          role="button"
          className={`navbar-burger burger  ${isActive ? 'is-active' : ''}`}
          aria-label="menu"
          aria-expanded="false"
          data-target="myMenu"
          href="/"
          onClick={(e) => {
            setIsActive(!isActive)
            e.preventDefault()
          }}
        >
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
          <span aria-hidden="true"></span>
        </a>
      </div>

      <div className={`navbar-menu ${isActive ? 'is-active' : ''}`} id="myMenu">
        <div className="navbar-start">
          {user.userId === -1 && (
            <>
              <Link
                to="/"
                className="navbar-item is-size-5"
                onClick={(e) => {
                  setIsActive(!isActive)
                }}
              >
                <span className="icon has-text-primary">
                  <FiWind />
                </span>
                <span>{choosenLang.home}</span>
              </Link>
              <Link
                to="/try/try"
                className="navbar-item is-size-5"
                onClick={(e) => {
                  setIsActive(!isActive)
                }}
              >
                <span className="icon has-text-primary">
                  <MdGpsNotFixed />
                </span>
                <span>{choosenLang.use}</span>
              </Link>
            </>
          )}

          {user.userId !== -1 && (
            <>
              <Link
                to="/sessions"
                className="navbar-item is-size-5"
                onClick={(e) => {
                  setIsActive(!isActive)
                }}
              >
                <span className="icon has-text-link">
                  <WiDayWindy />
                </span>
                <span>{choosenLang.sessions}</span>
              </Link>
              <Link
                to="/boards"
                className="navbar-item is-size-5"
                onClick={(e) => {
                  setIsActive(!isActive)
                }}
              >
                <span className="icon has-text-link">
                  <MdSurfing />
                </span>
                <span>{choosenLang.boards}</span>
              </Link>
              <Link
                to="/sails"
                className="navbar-item is-size-5"
                onClick={(e) => {
                  setIsActive(!isActive)
                }}
              >
                <span className="icon has-text-link">
                  <MdKitesurfing />
                </span>
                <span>{choosenLang.sails}</span>
              </Link>
              <Link
                to="/globalStats"
                className="navbar-item is-size-5"
                onClick={(e) => {
                  setIsActive(!isActive)
                }}
              >
                <span className="icon has-text-link">
                  <AiOutlineDotChart />
                </span>
                <span>{choosenLang.statsG}</span>
              </Link>
              <Link
                to="/rigsStats"
                className="navbar-item is-size-5"
                onClick={(e) => {
                  setIsActive(!isActive)
                }}
              >
                <span className="icon has-text-link">
                  <GiChart />
                </span>
                <span>{choosenLang.statsR}</span>
              </Link>
              {/* <Link
                to="/testzip"
                className="navbar-item is-size-5"
                onClick={(e) => {
                  setIsActive(!isActive)
                }}
              >
                <span>Testzip</span>
              </Link> */}
            </>
          )}
        </div>

        {user.userId !== -1 && (
          <div className="navbar-end">
            <div className="navbar-item has-dropdown is-hoverable">
              <a className="navbar-link">
                <span className="icon-text has-text-extensions has-text-info">
                  <span className="icon">
                    <i className="fa fas fa-user"></i>
                  </span>
                  <span>{user.userName}</span>
                </span>
              </a>

              <div className="navbar-dropdown is-boxed is-right">
                <div className="navbar-item">
                  <button
                    className={
                      'button is-small ' +
                      (user.accountType === subscribeAccount
                        ? 'is-info '
                        : 'is-primary ') +
                      'is-light'
                    }
                    onClick={(e) => {
                      handleModifyProfile()
                      setIsActive(!isActive)
                    }}
                    disabled={user.userName === demoUserName}
                    title={
                      user.userName === demoUserName
                        ? choosenLang.registeredOnly
                        : ''
                    }
                  >
                    {choosenLang.modify}
                  </button>
                </div>
                <div className="navbar-item">
                  <Link
                    to="/login"
                    className="button is-small is-warning is-light"
                    onClick={(e) => {
                      handleDisconnect()
                      setIsActive(!isActive)
                    }}
                  >
                    {choosenLang.disconnect}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        )}
        {user.userId === -1 && (
          <div className="navbar-item">
            <Link
              to="/login"
              className="button is-primary is-light"
              onClick={(e) => {
                setIsActive(!isActive)
              }}
            >
              {choosenLang.connect}
            </Link>
          </div>
        )}

        <div className="navbar-item">
          <Link
            to="/"
            onClick={(e) => {
              toggleLang()
              setIsActive(!isActive)
              e.preventDefault()
            }}
          >
            FR/ENG
          </Link>
        </div>
      </div>
    </nav>
  )
}

export default Header
